import { useSelectTheme } from "../../../store";
import { defaultSvgProps, SvgProps } from "../type/props";

export const DropdownIcon = (props?: SvgProps) => {
  const { color } = useSelectTheme();
  const { width, height, fill, style } = defaultSvgProps(props, {
    width: 20,
    height: 20,
    fill: color.textIcon.greyIcon,
    style: {
      flexShrink: 0,
    },
  });

  return (
    <svg
      width={width}
      height={height}
      style={style}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.666 4.58398C11.666 5.27434 11.1064 5.83398 10.416 5.83398C9.72566 5.83398 9.16602 5.27434 9.16602 4.58398C9.16602 3.89363 9.72566 3.33398 10.416 3.33398C11.1064 3.33398 11.666 3.89363 11.666 4.58398Z"
        fill={fill}
      />
      <path
        d="M11.666 9.58398C11.666 10.2743 11.1064 10.834 10.416 10.834C9.72566 10.834 9.16602 10.2743 9.16602 9.58398C9.16602 8.89363 9.72566 8.33398 10.416 8.33398C11.1064 8.33398 11.666 8.89363 11.666 9.58398Z"
        fill={fill}
      />
      <path
        d="M11.666 14.584C11.666 15.2743 11.1064 15.834 10.416 15.834C9.72566 15.834 9.16602 15.2743 9.16602 14.584C9.16602 13.8936 9.72566 13.334 10.416 13.334C11.1064 13.334 11.666 13.8936 11.666 14.584Z"
        fill={fill}
      />
    </svg>
  );
};
